import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Actions = styled(View, theme => {
  return {
    base: {
      display: 'flex',
      gap: theme.spacingInlineOnepulse,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      minWidth: theme.spacingStackTwentypulse,
      width: '100%',
      backgroundColor: theme.colorFormsFillDefault,
      borderRadius: theme.borderRadiusForm,
      borderWidth: theme.borderWidthHalfpulse,
      borderColor: 'transparent',
      paddingVertical: theme.paddingInsetOnepulse,
      paddingHorizontal: theme.paddingInsetThreepulse,
    },
    variants: {
      size: {
        md: {
          height: theme.sizingMedium,
          borderWidth: theme.borderWidthHalfpulse,
        },
        ml: {
          height: theme.sizingMediumlarge,
        },
        lg: {
          height: theme.sizingLarge,
        },
        xl: {
          height: theme.sizingExtralarge,
          borderRadius: theme.borderRadiusLargecontainer,
        },
      },
      isActive: {
        true: {
          borderWidth: theme.borderWidthHalfpulse,
          backgroundColor: theme.colorFormsFillFocused,
          borderColor: theme.colorActionBorderFocused,
          paddingHorizontal: theme.paddingInsetNone,
          paddingLeft: theme.paddingInsetTwopulse,
        },
      },
      isFilled: {
        true: {
          borderColor: theme.colorFormsBorderFilled,
          backgroundColor: theme.colorFormsFillFilled,
          borderWidth: theme.borderWidthQuarterpulse,
        },
      },
      hasError: {
        true: {
          borderWidth: theme.borderWidthQuarterpulse,
          borderColor: theme.colorFormsBorderError,
        },
      },
      disabled: {
        true: {
          backgroundColor: theme.colorFormsFillDisabled,
          borderColor: theme.colorFormsBorderDisabled,
          borderWidth: theme.borderWidthQuarterpulse,
        },
      },
      readonly: {
        true: {
          backgroundColor: theme.colorFormsFillReadonly,
          borderColor: theme.colorFormsBorderReadonly,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          isFilled: true,
          isActive: true,
        },
        css: {
          borderWidth: theme.borderWidthHalfpulse,
          borderColor: theme.colorActionBorderFocused,
          backgroundColor: theme.colorFormsFillFocused,
        },
      },
      {
        variants: {
          disabled: true,
          readonly: true,
        },
        css: {
          backgroundColor: theme.colorFormsFillDisabled,
          borderColor: theme.colorFormsBorderDisabled,
          borderWidth: theme.borderWidthQuarterpulse,
        },
      },
      {
        variants: {
          isFilled: true,
          isActive: true,
        },
        css: {
          borderWidth: theme.borderWidthHalfpulse,
          borderColor: theme.colorActionBorderFocused,
          backgroundColor: theme.colorFormsFillFocused,
          paddingRight: theme.paddingInsetTwopulse,
        },
      },
      {
        variants: {
          isFilled: false,
          isActive: true,
        },
        css: {
          paddingRight: theme.paddingInsetTwopulse,
        },
      },

      {
        variants: {
          isFilled: true,
          isActive: true,
          hasError: true,
        },
        css: {
          borderWidth: theme.borderWidthHalfpulse,
          borderColor: theme.colorFormsBorderError,
          backgroundColor: theme.colorFormsFillFocused,
        },
      },
      {
        variants: {
          isActive: true,
          hasError: true,
        },
        css: {
          borderWidth: theme.borderWidthHalfpulse,
          borderColor: theme.colorFormsBorderError,
          backgroundColor: theme.colorFormsFillFocused,
        },
      },
    ],
  }
})
